import React, { createContext, useContext, useEffect, useState } from "react";
import { database } from "../config/config";
import { get, ref } from "firebase/database";
import { useLocation } from "react-router-dom";
import { PROFILE_USERTYPE, TOKEN_KEY } from "../config/variable";
import { SavedUser } from "../config/storage";

const AppContext = createContext();

export const useAppContext = () => useContext(AppContext);

const ContextProvider = ({ children }) => {
  const [openReport, setOpenReport] = useState(false);
  const [openInVoicing, setOpenInVoicing] = useState(false);
  const [openscheduleGuardManagement, setOpenscheduleGuardManagement] =
    useState(false);

  const [showSideNav, setShowSideNav] = useState(true);

  const [isVisibleReport, setIsVisibleReport] = useState(false);
  const [isVisibleSchedule, setIsVisibleSchedule] = useState(false);
  const [isVisibleInvoicing, setVisibleInvoicing] = useState(false);
  const [isUserList, setIsUserList] = useState(false);
  const [OpenUserList, setOpenUserList] = useState(false);
  const [removeNav, setRemoveNav] = useState(false);
  const [ShowPopUp, setShowPopUP] = useState(false);
  const [popUpData, setPopUpData] = useState("");

  const [showSignUp, setShowSignUp] = useState(false); // Tracks whether to show the registration form
  const HandlePopUpClose = () => {
    setShowPopUP(false);
  };

  const [isChangesInCreateReport, setIsChangesInCreateReport] = useState(false);

  const [UserType, setUserType] = useState(SavedUser);
  const [isLoading, setIsLoading] = useState(true);

  // useEffect(() => {
  //   const checkAuth = async () => {
  //     setIsLoading(true);
  //     try {
  //       // Your auth check logic here
  //       // setUserType based on result
  //     } catch (error) {
  //       console.error("Auth check failed:", error);
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   };

  //   checkAuth();
  // }, []);

  // POPUP
  // popup
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");

  // authentication
  const isRoleCorrect = SavedUser?.role === PROFILE_USERTYPE;
  const auth = isRoleCorrect && SavedUser ? true : false;
  const [isAuthenticated, setIsAuthenticated] = useState(auth);

  console.log("UserType(appcontext)", UserType);
  return (
    <AppContext.Provider
      value={{
        openReport,
        setOpenReport,
        openscheduleGuardManagement,
        setOpenscheduleGuardManagement,
        showSideNav,
        setShowSideNav,
        openInVoicing,
        setOpenInVoicing,
        isVisibleReport,
        setIsVisibleReport,
        isVisibleSchedule,
        setIsVisibleSchedule,
        isVisibleInvoicing,
        setVisibleInvoicing,
        isUserList,
        setIsUserList,
        OpenUserList,
        setOpenUserList,
        removeNav,
        setRemoveNav,
        ShowPopUp,
        setShowPopUP,
        popUpData,
        setPopUpData,
        HandlePopUpClose,
        isChangesInCreateReport,
        setIsChangesInCreateReport,
        UserType,
        isLoading,
        setIsLoading,
        SavedUser,
        isPopupOpen,
        setIsPopupOpen,
        popupMessage,
        setPopupMessage,
        isAuthenticated,
        setIsAuthenticated,
        showSignUp,
        setShowSignUp,
        // reportTemplates,
        // setReportTemplates,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export default ContextProvider;


// export const UserData =